export default __webpack_public_path__ + "static/media/cio-plus.c2dcb49b.png";